module.exports = __webpack_public_path__ + "static/media/00-eComic-series_4x.52af6ba7.png";